// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
let Invitation
export default Invitation = class Invitation extends (
  require("lib/static-shim").default(require("lib/utils/model").default)
) {
  url() {
    const { invite_token, invitation_type } = this.attributes
    if (!this.get("invite_token")) {
      console.error("Cannot fetch Invitation without an invite_token set.")
    }
    return this.urlRoot(
      `api/private/invitation/${this.get(
        "invite_token"
      )}/?type=${invitation_type}`
    )
  }
}
